import Button from '@anm/components/buttons/Button';
import { TeamMemberInviteFormFields } from '@anm/components/team/TeamMemberInviteForm';
import TeamMemberInviteForm from '@anm/components/team/TeamMemberInviteForm/index';
import TeamModal from '@anm/components/team/TeamModal';
import useDependPendingCallback from '@anm/hooks/useDependPendingCallback';
import useSwitchState from '@anm/hooks/useSwitchState';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { teamActions, teamSelectors } from '../../../store/modules/team';
import { userSelectors } from '../../../store/modules/user';

export type InviteMemberProps = {};

const InviteMember: FC<InviteMemberProps> = () => {
  const [isOpen, open, close] = useSwitchState();
  const dispatch = useDispatch();
  const userPermissions = useSelector(userSelectors.selectTeamPermissions);

  const isPending = useSelector(teamSelectors.selectMemberInvitePending);

  const handleSubmit = ({ email, displayName, role }: TeamMemberInviteFormFields) => {
    dispatch(teamActions.inviteMember({ email, role, name: displayName }));
  };

  useDependPendingCallback(isPending, close);

  return (
    <>
      {isOpen && (
        <TeamModal title="Invite new team member" onModalClose={close}>
          <TeamMemberInviteForm
            permissions={userPermissions}
            isPending={isPending}
            initialValues={{ displayName: '', email: '', role: 'VIEWER' }}
            onSubmit={handleSubmit}
          />
        </TeamModal>
      )}
      <Button size="large_long" variant="light-blue" onClick={open}>
        Invite Member
      </Button>
    </>
  );
};

export default InviteMember;
